<div class="flex gap-4" style="height: calc(90vh - 120px)">
  <div class="flex flex-col w-[40%]" style="min-height: 0">
    @if (drawingPricingGeometry; as drawingGeometry) {
      <div class="h-full min-h-0 flex flex-col gap-3 px-2">
        <p class="text-sm font-semibold text-surface-switch-900">
          {{ drawingGeometry.name }}
        </p>
        @if (drawingLoading) {
          <div class="h-full flex flex-col items-center justify-center gap-2">
            <p-progress-spinner
              ariaLabel="Loading drawing preview"
              strokeWidth="10"
            />
            <p class="text-sm text-muted-color">Loading drawing preview...</p>
          </div>
        } @else if (drawingError) {
          <p-message severity="error" styleClass="w-full">
            {{ drawingError }}
          </p-message>
        } @else {
          <app-pdf-viewer [fileUrl]="drawingFileUrl" />
        }
      </div>
    }
  </div>

  <p-divider layout="vertical" />

  <div class="flex flex-col w-[60%] overflow-y-auto" style="min-height: 0">
    <p-tabs
      [value]="
        activePanel === 'capex'
          ? 'capex'
          : activePanel === 'consumables' && showConsumablesTab
            ? 'consumables'
            : activePanel === 'pricing'
              ? 'pricing'
              : activePanel === 'drawing'
                ? 'drawing'
                : 'details'
      "
      (valueChange)="activePanel = $any($event)"
    >
      <p-tablist>
        <p-tab value="details">Item Details</p-tab>
        <p-tab value="drawing">Drawing Information</p-tab>
        <p-tab value="pricing">Pricing Information</p-tab>
        @if (tradeStudyToolFeaturesEnabled) {
          <p-tab value="capex">CapEx</p-tab>
        }
        @if (showConsumablesTab) {
          <p-tab value="consumables">Consumables</p-tab>
        }
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="details">
          <app-quote-revision-item-details-panel
            [item]="item"
            [currencyCode]="currencyCode"
            [tradeStudyToolFeaturesEnabled]="tradeStudyToolFeaturesEnabled"
            (relinkCadRequested)="relinkCadRequested.emit()"
          />
        </p-tabpanel>
        <p-tabpanel value="drawing">
          @if (drawingLoading) {
            <div class="flex flex-col p-2 pr-4">
              <p class="text-sm text-muted-color">
                Loading drawing information...
              </p>
            </div>
          } @else if (drawingError) {
            <div class="flex flex-col p-2 pr-4">
              <p-message severity="warn" styleClass="w-full">
                {{ drawingError }}
              </p-message>
            </div>
          } @else {
            <app-drawing-extraction-info [drawingFile]="drawingFile" />
          }
        </p-tabpanel>
        @if (drawingPricingGeometry; as drawingGeometry) {
          <p-tabpanel value="pricing">
            <h4 class="text-lg font-semibold mb-4">
              {{ drawingGeometry.name }}
            </h4>
            <app-quote-revision-item-pricing-information
              [item]="item"
              [selectedCadObjectId]="drawingGeometry.id"
              [currencyCode]="currencyCode"
            />
          </p-tabpanel>
        }
        @if (tradeStudyToolFeaturesEnabled) {
          <p-tabpanel value="capex">
            <app-quote-revision-item-capex-information
              [item]="item"
              [currencyCode]="currencyCode"
              [readOnly]="readOnly"
            />
          </p-tabpanel>
        }
        @if (showConsumablesTab) {
          <p-tabpanel value="consumables">
            <app-quote-revision-item-consumables-information
              [item]="item"
              [currencyCode]="currencyCode"
              [readOnly]="readOnly"
            />
          </p-tabpanel>
        }
      </p-tabpanels>
    </p-tabs>
  </div>
</div>
